import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

// Auth
export const authComputed = {
  ...mapState('auth', ['currentUser']),
  ...mapGetters('auth', ['loggedIn', 'userProfile', 'userProgress', 'userMainGoal', 'userMetrics', 'userProgram']),
};
export const authMethods = {
  ...mapMutations('auth', ['setCurrentUser']),
  ...mapActions('auth', [
    'hydrate',
    'logIn',
    'logOut',
    'resetPassword',
    'confirmPasswordReset',
    'validate',
    'checkout',
    'lookupCoupon',
    'autoLogin',
  ]),
};

// CLIENT
export const clientComputed = {
  ...mapGetters('client', ['initialLandingPage', 'clientId', 'trainerId', 'orgId']),
};
export const clientMethods = {
  ...mapMutations('client', ['updateOnboardingProgress']),
  ...mapActions('client', ['signUp', 'updateClient', 'changePassword', 'startCheckin', 'updateCheckin', 'completeCheckin']),
};

// HOME
export const homeComputed = {
  ...mapState('home', ['homeOverview', 'progressDetails', 'selectedDay', 'viewChatList', 'isLoadingProgress']),
};
export const homeMethods = {
  ...mapMutations('home', ['setSelectedDay', 'setViewChatList', 'setIsLoadingProgress', 'setHomeOverview']),
  ...mapActions('home', ['getHomeOverview', 'getProgressDetails']),
};

// MEDIA UPLOAD
export const mediaUploadComputed = {
  ...mapGetters('mediaUpload', ['hasNewMedia']),
};
export const mediaUploadMethods = {
  ...mapMutations('mediaUpload', ['setSignedPostData']),
  ...mapActions('mediaUpload', ['getS3UploadUrl', 'uploadPhoto']),
};

// MODALS
export const modalComputed = {
  ...mapState('modal', ['selectedVideo', 'confirmationModalCtx', 'inputModalLabel']),
};
export const modalMethods = {
  ...mapMutations('modal', ['setSelectedVideo', 'setConfirmationModalCtx', 'setInputModalLabel']),
};

// ORG
export const orgComputed = {
  ...mapState('org', ['orgDetails']),
  ...mapGetters('org', ['storeUrls']),
  ...mapGetters('org', ['backgroundImg']),
  ...mapGetters('org', ['primaryColor']),
  ...mapGetters('org', ['darkLogoUrl']),
  ...mapGetters('org', ['lightLogoUrl']),
  ...mapGetters('org', ['sitename'])
};
export const orgMethods = {
  ...mapActions('org', ['getOrgDetails']),
};

// PROFILE
export const profileComputed = {
  ...mapGetters('profile', ['activeSubscription']),
};

// PROGRAM
export const programComputed = {
  ...mapState('program', ['workoutDetails', 'programDay']),
};
export const programMethods = {
  ...mapMutations('program', ['setProgramDay', 'setWorkoutDetails']),
  ...mapActions('program', ['getProgramDay']),
};

// TRAINER
export const trainerComputed = {
  ...mapState('trainer', ['myTrainer']),
};
export const trainerMethods = {
  ...mapActions('trainer', ['getMyTrainer']),
};

// VIDEO
export const videoComputed = {
  ...mapState('video', ['videoAction', 'remainingVideoTime', 'currentVideoTime', 'videoDuration', 'isTimerPaused']),
};
export const videoMethods = {
  ...mapMutations('video', ['setVideoAction', 'setRemainingVideoTime', 'setCurrentVideoTime', 'setVideoDuration']),
};

// WORKOUT
export const workoutComputed = {
  ...mapState('workout', [
    'selectedWorkout',
    'currentCircuit',
    'currentExercise',
    'nextCircuit',
    'prevCircuit',
    'nextExercise',
    'prevExercise',
    'currentExerciseIndex',
    'currentCircuitIndex',
    'currentSetIndex',
    'restType',
    'isTransitionPeriod',
    'isLastCircuit',
    'isLastExercise',
    'completedWorkoutElements',
    'currentExerciseSetTime',
    'completedWorkoutDuration',
    'isLoadingExercise',
    'clientSetDirections',
    'showCircuitIntro',
    'isWorkoutUpdate',
    'afterSetRest',
    'isBeginningOfWorkout',
    'skipRestPeriod',
  ]),
  ...mapGetters('workout', ['isEndOfWorkout']),
};
export const workoutMethods = {
  ...mapMutations('workout', [
    'setSelectedWorkout',
    'setCurrentCircuit',
    'setCurrentExercise',
    'setPrevCircuit',
    'setNextCircuit',
    'setPrevExercise',
    'setNextExercise',
    'setCurrentCircuitIndex',
    'setCurrentExerciseIndex',
    'setCurrentSetIndex',
    'setRestType',
    'setIsTransitionPeriod',
    'setForceEndWorkout',
    'setUpdatePostWorkoutReview',
    'setCompletedWorkoutElements',
    'setCurrentExerciseSetTime',
    'setCompletedWorkoutDuration',
    'setIsLoadingExercise',
    'setClientSetDirections',
    'setShowCircuitIntro',
    'setIsWorkoutUpdated',
    'setAfterSetRest',
    'setIsBeginningOfWorkout',
    'setSkipRestPeriod',
  ]),
  ...mapActions('workout', ['startWorkout', 'updateWorkout', 'completeWorkout']),
};

// NUTRITION
export const nutritionComputed = {
  ...mapState('nutrition', ['isNutritionUpdated']),
};
export const nutritionMethods = {
  ...mapMutations('nutrition', ['setIsNutritionUpdated']),
};
